import styled from 'styled-components';
import { comum } from '../../styles/Themes/light';

interface MenuContentProps {
    isOpen: boolean;
}

interface MenuItemProps {
    isActive: boolean;
}

interface ProfileFooterProps {
    isAdmin: boolean;
    inProfile: boolean;
}

export const Container = styled.div`
    position: relative;
    width: auto;
    z-index: 1001;
    pointer-events: none;
`;

export const Overlay = styled.div<MenuContentProps>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
    visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
    transition: opacity 0.3s ease-in-out;
`;

export const MenuButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.interfacePure0};
    border-radius: 5px;
    margin: 8px;
    box-shadow: 0px 2px 10px rgba(0,0,0, 0.15);
    position: relative;
    z-index: 1002;
    pointer-events: auto;

    svg {
        path {
            fill: ${({ theme }) => theme.colors.interfaceGray300}
        }
    }
`;

export const MenuContent = styled.div<MenuContentProps>`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 320px;
    height: 100vh;
    background-color: ${(props: any) => props.theme.colors.interfacePure0};
    z-index: 1000;
    transform: translateX(${({ isOpen }) => (isOpen ? '0' : '-100%')});
    transition: transform 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
    pointer-events: auto;
`;

export const MenuHeader = styled.div`
    padding: 16px;
    border-bottom: 1px solid ${(props: any) => props.theme.colors.ce5e5e5};
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const LogoContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    margin: 5px 10px;
`;

export const MenuList = styled.ul`
    list-style: none;
    padding: 0 0 20px 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    overflow-y: auto;
`;

export const MenuItem = styled.li<MenuItemProps>`
    a {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 16px;
        text-decoration: none;
        color: ${({ theme }) => theme.colors.interfaceGray300};
        background-color: ${({ isActive }) => (isActive ? 'var(--cf5f5f5)' : 'transparent')};
        transition: all 0.2s ease;
        position: relative;

        &:hover {
            background-color: ${(props: any) => props.theme.colors.cf5f5f5};
        }

        span {
            font-size: 16px;
            font-weight: 500;
        }

        svg {
            width: 24px;
            height: 24px;
            flex-shrink: 0;
            path {
                fill: ${({ theme }) => (theme.colors.interfaceGray300 )};
            }
        }
        svg.bell {
            width: 24px;
            height: 24px;
            flex-shrink: 0;
            path { fill: none}
        }

        .notification {
            position: absolute;
            right: 35px;
            top: 50%;
            width: 27px;
            min-width: 16px;
            transform: translateY(-50%);
            background-color: ${({ isActive, theme }) => (isActive ? theme.colors.primaryRed400 : 'var(--count-badge-bg)') };
            color: ${(props: any) => props.theme.colors.pureWhite};
            font-size: 12px;
            font-weight: 600;
            min-width: 20px;
            height: 20px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 14px;
        }
    }
`;

export const SectionFooter = styled.div<ProfileFooterProps>`
    padding: 16px;
    border-top: 1px solid ${(props: any) => props.theme.colors.ce5e5e5};
    border-radius: 8px 8px 0 0;
    background-color: ${({ isAdmin }) => (isAdmin ? comum.colors.primaryRed400 : comum.colors.interfaceGray600)};
    color: ${(props: any) => props.theme.colors.pureWhite};
    font-weight: bold;
`;

export const ProfileFooter = styled.div<ProfileFooterProps>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-height: 25px;

    .avatarUser {
        position: relative;
        bottom: 27px;
        width: 40px;
        height: 40px;
        border-radius: 25%;
        background-color: ${({ isAdmin }) => (isAdmin ? comum.colors.primaryRed600 : comum.colors.interfaceGray500)};
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .sideButtonFooter {
        background: none;
        border: none;
        cursor: pointer;
        padding: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
`;

export const DescriptionProfileFooter = styled.div<ProfileFooterProps>`
    h2 {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
        color: ${(props: any) => props.theme.colors.pureWhite};
    }

    span {
        font-size: 14px;
        opacity: 0.8;
    }
`; 